import React from "react";
import { connect } from "react-redux";
import axios from "axios";
import "../styles/topicrendering.css";
import * as searchTopicActions from "../redux/actions/searchTopicActions";
import TopicHeader from "../components/topicdetail/TopicHeader";
import TopicMiddlePanes from "../components/topicdetail/TopicMiddlePanes";
import TopicNav from "../components/topicdetail/TopicNav";
import Loader from "./Loader";
import { trackPageView } from "../components/DataLayer";
import config from "../config/config";
var Settings = require("../components/settings.json");

class TopicDetail extends React.Component {
  constructor() {
    super();
    this.state = {};
  }
  fetchTopicData = () => {
    let url = config.BASE_URL + Settings["loadTopicRenderingUrl"];
    let userEmail = this.props.logInResponse.isLoggedIn
      ? this.props.logInResponse.email
      : "null";
    let urlToHit = url.replace("id", this.props.match.params.id);

    axios
      .get(urlToHit, {
        params: {
          email: userEmail,
        },
      })
      .then((response) => {
        if (response.status === 200) {
          this.setState({ topicDetail: response.data.response }, () => {
            if (!this.state.topicDetail.hasAccess) {
              this.props.history.push({
                redirectFrom: response.config.url.split("/")[5],
                pathname: "/non-free-topic",
                state: this.state.topicDetail.hasAccess,
              });
            }
          });
        } else {
          throw new Error("Something went wrong ...");
        }
      })
      .catch((e) => {
        console.log(e);
      });
  };
  componentDidMount = () => {
    trackPageView();
    this.fetchTopicData();
  };
  componentDidUpdate = (prevProps) => {
    document.body.scrollTop = document.documentElement.scrollTop = 0;
    if (prevProps.match.params.id !== this.props.match.params.id) {
      this.setState({ topicDetail: null }, () => {
        trackPageView();
        this.fetchTopicData();
      });
    }
  };

  render() {
    const { topicDetail } = this.state;

    let displayContent =
      topicDetail && topicDetail.topicTitle !== null ? (
        <div>
          <TopicNav />
          <TopicHeader
            author={topicDetail.author}
            topContent={topicDetail.topContent}
            handout={topicDetail.handoutS3Path}
            bookTitle={topicDetail.bookTitle}
            topicTitle={topicDetail.topicTitle}
            printContent={topicDetail.topicContent}
          />
          <TopicMiddlePanes
            leftPane={topicDetail.leftPaneSubTopics}
            content={topicDetail.topicContent}
            rightPane={topicDetail.rightPaneTopics}
          />
        </div>
      ) : (
        <Loader />
      );
    return <div className="topicdetail">{displayContent}</div>;
  }
}

const mapStateToProps = (state) => ({
  topicDetail: state.topicRender.response,
  logInResponse: state.loginReducer,
});

const mapDispatchToProps = (dispatch) => ({
  renderTopic: (topicRenderUrl) =>
    dispatch(
      searchTopicActions.fetchDataFromServices(
        topicRenderUrl,
        "getTopicRenderingData"
      )
    ),
});

export default connect(mapStateToProps, mapDispatchToProps)(TopicDetail);
